import styled from 'styled-components';
import { ButtonStyled } from 'components/UI/styled/button-styled';

export const FormSection = styled.h4`
  font-size: 16px;
  display: flex;
  align-items: center;
  margin: 20px 0;

  span {
    color: #4A90E2 !important;
    margin: 0 0 0 10px;
    font-size: 18px !important;
  }
`;

export const FormToolbar = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SubmitButton = styled(ButtonStyled)`
  margin: 0 !important;
`;

export const CancelButton = styled(ButtonStyled)`
  background: #FFF !important;
  border: 1px solid #E4E9F0 !important;
  color: #98A2B3;
  margin: 0 12px 0 0 !important;

  &:hover {
    color: #777 !important;
  }
  
  &:active {
    color: #777 !important;
  }
`;

